import classNames from "classnames";
import { Fragment, useMemo } from "react";

export type HeadingType = {
  text: string;
  highlight?: boolean;
  lineBreak?: boolean;
  customHighlightClass?: string;
}[];

type HeadingPropsType = {
  heading: HeadingType;
  fontStyle: // | "text-title-10"
  // | "text-title-12"
  // | "text-title-14"
  // | "text-title-16"
  // | "text-title-20"
  // | "text-title-24"
  // | "text-title-32"
  // | "text-title-48"
  // | "text-display-64"
  // | "text-display-64B"
  // | "text-body-10"
  // | "text-body-12"
  // | "text-body-14"
  // | "text-body-16"
  // | "text-body-24"
  | "text-title-20 sm:text-title-32"
    | "text-title-24 sm:text-title-40"
    | "text-title-32 sm:text-display-64"
    | "text-title-32 lg:text-title-48" // For marketing page
    | "text-title-20 lg:text-title-24"; // For marketing page (modal)
  as: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  fontBaseColor?: string;
  fontHighlightColor?: string;
  align?: "text-center" | "text-left" | "text-right";
};

const Heading = ({
  heading,
  as,
  fontStyle,
  fontBaseColor = "text-grey-4",
  fontHighlightColor = "text-purple-3",
  align,
}: HeadingPropsType) => {
  const className = useMemo(
    () =>
      classNames(
        fontStyle,
        fontBaseColor,
        // "text-title3 font-semibold text-grey-4 sm:text-title1"
        // `${align ? align : "text-center"}`
        align
      ),
    [fontBaseColor, fontStyle, align]
  );

  const renderBody = () => {
    return heading.map(({ text, highlight, lineBreak }, index) => {
      const trimmedText = text.trim(); // Trim the text
      const space = index < heading.length - 1 && !lineBreak ? " " : ""; // Add space if not the last element and no line break

      return (
        <Fragment key={text}>
          {highlight ? (
            <span
              className={classNames(fontHighlightColor, {
                "sm:text-display-64B":
                  fontStyle === "text-title-32 sm:text-display-64",
              })}
            >
              {trimmedText}
            </span>
          ) : (
            <span>{trimmedText}</span>
          )}
          {lineBreak && <br />}
          {space && <span>{space}</span>}
        </Fragment>
      );
    });
  };

  if (heading?.length <= 0) return null;

  switch (as) {
    case "h1": {
      return <h1 className={className}>{renderBody()}</h1>;
    }
    case "h2": {
      return <h2 className={className}>{renderBody()}</h2>;
    }
    case "h3": {
      return <h3 className={className}>{renderBody()}</h3>;
    }
    case "h4": {
      return <h4 className={className}>{renderBody()}</h4>;
    }
    case "h5": {
      return <h5 className={className}>{renderBody()}</h5>;
    }
    case "h6": {
      return <h6 className={className}>{renderBody()}</h6>;
    }
    case "p": {
      return <p className={className}>{renderBody()}</p>;
    }

    default: {
      return null;
    }
  }
};

export default Heading;
